import React, { useMemo } from "react";
import moment from "moment";
import { shiftType } from "services/shiftsService";

const MobileCalendarGrid = ({
	month,
	selectedDay,
	onSelectDay,
	daysByKey,
	plansByKey,
}) => {
	const cells = useMemo(() => {
		const startOfMonth = month.clone().startOf("month");
		const endOfMonth = month.clone().endOf("month");

		// Rellenar días vacíos al inicio (lunes como primer día)
		const leadingBlanks = (startOfMonth.isoWeekday() + 6) % 7;
		const daysInMonth = endOfMonth.date();

		const result = [];
		for (let i = 0; i < leadingBlanks; i++) {
			result.push({ blank: true, key: `blank-start-${i}` });
		}
		for (let d = 1; d <= daysInMonth; d++) {
			const mDay = startOfMonth.clone().date(d);
			const key = mDay.format("YYYY-MM-DD");
			result.push({ blank: false, key, date: d, iso: key });
		}
		// Rellenar al final para completar la última semana
		while (result.length % 7 !== 0) {
			result.push({
				blank: true,
				key: `blank-end-${result.length}`,
			});
		}
		return result;
	}, [month]);

	const todayKey = moment().format("YYYY-MM-DD");

	const getWorkShiftColor = (plan) => {
		if (!plan || !plan.assignments || plan.assignments.length === 0)
			return null;
		const workShift = plan.assignments.find(
			(a) =>
				a.shift &&
				a.shift.type === shiftType.work &&
				a.shift.background_color
		);
		if (workShift) return workShift.shift.background_color;

		const firstWithColor = plan.assignments.find(
			(a) => a.shift && a.shift.background_color
		);
		return firstWithColor ? firstWithColor.shift.background_color : null;
	};

	const isDayWorkable = (plan) => {
		if (!plan || !plan.assignments) return false;
		return plan.assignments.some(
			(a) => a.shift && a.shift.type === shiftType.work
		);
	};

	return (
		<div className="mobile-calendar-grid">
			<div className="mobile-calendar-grid__weekdays">
			{Array.from({ length: 7 }, (_, i) => {
				const label = moment().isoWeekday(i + 1).format("dd");
				return (
					<div key={i} className="mobile-calendar-grid__weekday">
						{label}
					</div>
				);
			})}
			</div>

			<div className="mobile-calendar-grid__cells">
				{cells.map((cell) => {
					if (cell.blank) {
						return (
							<div
								key={cell.key}
								className="mobile-calendar-grid__cell mobile-calendar-grid__cell--blank"
							/>
						);
					}

					const dayData = daysByKey.get(cell.iso);
					const plan = plansByKey.get(cell.iso);

					const isHoliday = !!dayData?.day_type?.holiday;
					const isWorkedHoliday = !!dayData?.worked_holiday;
					const hasAbsence = !!dayData?.absence;
					const isWorkShift = isDayWorkable(plan);
					const hasAssignments = !!(
						plan &&
						plan.assignments &&
						plan.assignments.length > 0
					);
					const shiftColor = getWorkShiftColor(plan);

					const isToday = cell.iso === todayKey;
					const isSelected = cell.iso === selectedDay;

					const classes = [
						"mobile-calendar-grid__cell",
						isSelected && "mobile-calendar-grid__cell--selected",
						isToday && "mobile-calendar-grid__cell--today",
						isHoliday && "mobile-calendar-grid__cell--holiday",
						isWorkedHoliday &&
							"mobile-calendar-grid__cell--worked-holiday",
						hasAbsence && "mobile-calendar-grid__cell--absence",
					]
						.filter(Boolean)
						.join(" ");

					const dotStyle =
						shiftColor && !isSelected
							? { backgroundColor: shiftColor }
							: undefined;

					return (
						<button
							key={cell.key}
							type="button"
							className={classes}
							onClick={() => onSelectDay(cell.iso)}
						>
							<span className="mobile-calendar-grid__date">
								{cell.date}
							</span>
							{(hasAssignments || hasAbsence) && (
								<span
									className={
										"mobile-calendar-grid__dot" +
										(isWorkShift
											? ""
											: " mobile-calendar-grid__dot--muted")
									}
									style={dotStyle}
								/>
							)}
						</button>
					);
				})}
			</div>
		</div>
	);
};

export default MobileCalendarGrid;
